var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.251,
    height: 102.892,
    viewBox: "0 0 111.251 102.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M224.2,228.511H182.826V193.142a155.2,155.2,0,0,1,1.715-24.758c1.138-6.9,2.869-12.56,5.145-16.827A54.61,54.61,0,0,1,201.315,136.5a64.089,64.089,0,0,1,16.88-10.879l9.431,15.006c-7.821,3.27-13.663,8.209-17.363,14.683s-5.789,16.027-6.216,28.4H224.2v44.8Zm66.45,0h-41.37V193.142a155.234,155.234,0,0,1,1.715-24.758c1.138-6.9,2.869-12.56,5.144-16.827A54.61,54.61,0,0,1,267.764,136.5a64.089,64.089,0,0,1,16.88-10.879l9.432,15.006c-7.823,3.27-13.664,8.21-17.363,14.683s-5.79,16.029-6.216,28.4h20.149v44.8Z",
    transform: "translate(-182.826 -125.619)",
    fill: "#fafafa",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommaIcon);
export default __webpack_public_path__ + "static/media/comma-icon.c6732a96b2a492581df0c659269df5fd.svg";
export { ForwardRef as ReactComponent };